import React, { useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideResidentialModal,
  setFormResiData,
} from "./modalSlices/ResidentialModalSlice";
import {
  fetchConstructionTypeAndYear,
  fetchFloorMassResi,
  fetchPropertyAreaResi,
} from "../property/propertySlice";

const ResidentialModal = ({ onClose, dcode, srocode }) => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.ResidentialModal.Residentialshow);
  const formResiData = useSelector(
    (state) => state.ResidentialModal.formResiData
  );
  const {
    floorMassResiOptions,
    propertyAreaResiOptions,
    subStructType,
    depreciationMas,
  } = useSelector((state) => state.property);

  useEffect(() => {
    // Fetch floor mass residential data when modal opens
    dispatch(fetchFloorMassResi({ dcode, srocode }));
  }, [dcode, srocode]);

  const handleChange = async (e) => {
    //debugger;
    const { name, value } = e.target;
    console.log("Selected floorType:", value);
    await dispatch(setFormResiData({ [name]: value }));
  };

  useEffect(() => {
    //debugger;
    if (formResiData.floorType) {
      // Fetch floor mass residential data when modal opens
      dispatch(fetchPropertyAreaResi({ dcode, srocode }));
    }
  }, [formResiData.floorType, dcode, srocode]);

  useEffect(() => {
    if (formResiData.propertyArea) {
      const structclass_code = formResiData.propertyArea;
      //debugger;
      // Fetch floor mass residential data when modal opens
      dispatch(
        fetchConstructionTypeAndYear({
          dcode,
          srocode,
          structclass_code,
        })
      );
    }
  }, [dcode, srocode, formResiData.propertyArea, dispatch]);

  const handleClose = () => {
    dispatch(hideResidentialModal());
    if (onClose) onClose();
  };

  const handleAddDetails = (e) => {
    e.preventDefault();
    console.log("Added data:", formResiData);
    handleClose(); // Close the modal after adding details
  };

  return (
    <Transition show={show} as={React.Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 overflow-y-auto"
        onClose={handleClose}
      >
        <div className="flex items-center justify-center min-h-screen">
          <div className="bg-gray-50 shadow-lg shadow-gray-300 overflow-hidden  max-w-xl w-full">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-md font-medium mx-8 text-black mb-4">
                Residential / Agriculture Construction
              </h3>
              <form onSubmit={handleAddDetails}>
                <div className="space-y-4">
                  {/* Floor Type */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="floorType"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Floor Type:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <select
                        id="floorType"
                        name="floorType"
                        value={formResiData.floorType || ""}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      >
                        {floorMassResiOptions.map((option) => (
                          <option
                            key={option.floorcode}
                            value={option.floorcode}
                          >
                            {option.floorname}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {/* Property Area */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="propertyArea"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Property Area:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <select
                        id="propertyArea"
                        name="propertyArea"
                        value={formResiData.propertyArea || ""}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      >
                        {propertyAreaResiOptions.map((option) => (
                          <option
                            key={option.structclass_code}
                            value={option.structclass_code}
                          >
                            {option.structclass_desc}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {/* Construction Type */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="constructionType"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Construction Type:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <select
                        id="constructionType"
                        name="constructionType"
                        value={formResiData.constructionType}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      >
                        {subStructType.map((option) => (
                          <option
                            key={option.substructclass_code}
                            value={option.substructclass_code}
                          >
                            {option.substructclass_desc}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {/* Construction Year */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="constructionYear"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Construction Year:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <select
                        id="constructionYear"
                        name="constructionYear"
                        value={formResiData.constructionYear}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      >
                        {depreciationMas.map((option) => (
                          <option key={option.year} value={option.year}>
                            {option.year}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {/* Area */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="area"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Area:
                    </label>
                    <div className="block w-full relative sm:col-span-2 col-span-2">
                      <input
                        id="area"
                        name="area"
                        value={formResiData.area}
                        onChange={handleChange}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {/* Rate */}
                  <div className="grid gap-4 m-8 sm:grid-cols-3 grid-cols-3 items-center text-sm">
                    <label
                      htmlFor="rate"
                      className="block w-full relative text-sm font-semibold sm:col-span-1 grid-cols-1"
                    >
                      Rate:
                    </label>
                    <p className="block w-full relative sm:col-span-2 col-span-2"></p>
                  </div>
                </div>
                <div className="flex justify-center mt-6">
                  <button
                    className="px-6 py-1.5 m-2 bg-blue-500 text-white rounded-full text-md"
                    type="submit"
                    onClick={handleAddDetails}
                  >
                    Save
                  </button>
                  <button
                    className="px-6 py-1.5 m-2 bg-red-500 text-white rounded-full text-md"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ResidentialModal;
